import {
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      retry: 1,
    },
  },
});

export { useMutation, useQuery, useQueryClient };

export function unwrapApiResult<T>(
  result: { success: boolean; data?: T; error?: string }
): T {
  if (!result.success) throw new Error(result.error || 'Unknown error');
  return result.data as T;
}
